import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { gsap } from "gsap";

const animateSlideContent = (slide: HTMLElement) => {
  const elements = slide.querySelectorAll<HTMLElement>(
    ".hero-slider__title, .hero-slider__sub-title, .hero-slider__actions",
  );

  if (elements.length === 0) {
    return;
  }

  gsap.set(elements, { autoAlpha: 0, y: 40 });

  gsap.to(elements, {
    autoAlpha: 1,
    y: 0,
    duration: 0.8,
    stagger: 0.2,
    ease: "power2.out",
    delay: 0.2,
  });
};

const resetAllSlides = (swiper: Swiper) => {
  const allElements = swiper.el.querySelectorAll<HTMLElement>(
    ".hero-slider__title, .hero-slider__sub-title, .hero-slider__actions",
  );

  if (allElements.length === 0) {
    return;
  }

  gsap.set(allElements, { autoAlpha: 0, y: 40 });
};

export const initHeroSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".hero-slider .swiper",
  );

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    // Find the pagination element inside this specific slider
    const paginationEl = sliderElement.querySelector<HTMLElement>(
      ".hero-slider__pagination",
    );

    new Swiper(sliderElement, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      on: {
        init: (swiper) => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          animateSlideContent(activeSlide);
        },
        slideChangeTransitionStart: (swiper) => {
          resetAllSlides(swiper);
          const activeSlide = swiper.slides[swiper.activeIndex];
          animateSlideContent(activeSlide);
        },
      },
    });
  });

  console.log("[HeroSlider] Isolated Swiper instances initialized with GSAP.");
};
